// removed by extract-text-webpack-plugin
module.exports = {"ring-switcher":"ring-switcher__398US"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Application/coms/DeviceDetail/coms/LRAPView/coms/RingSwitcher/styles/main.scss
// module id = 2239
// module chunks = 1